import React from "react";
import "./style.scss";
import CheckoutPaymentInStore from "../../sections/checkout-payment-in-store";
import CheckoutPaymentOnline from "../../sections/checkout-payment-online";
import { connect } from "react-redux";
import { staffInfoSelector } from "../../selectors/application";

const CheckoutPayment = props => {
  const { staffInfo } = props;
  if (staffInfo) {
    return <CheckoutPaymentInStore {...{ ...props, staffInfo }} />;
  } else {
    return <CheckoutPaymentOnline {...props} />;
  }
};
const mapStateToProps = state => ({
  staffInfo: staffInfoSelector(state)
});
export default connect(mapStateToProps)(CheckoutPayment);
